import Phaser from "phaser";
import {
  SHADOW_DISPLAY_ALPHA,
  SHADOW_SCALE_MULTIPLIER,
} from "@/shadow/constants";

const TEX = "def-shadow-spritesheet";
const ANIM_IDLE = "def-shadow-idle";

export function defenderShadowTexturesReady(scene: Phaser.Scene): boolean {
  return scene.textures.exists(TEX) || scene.textures.exists("def-shadow-idle");
}

function applyDefenderShadowScale(sprite: Phaser.GameObjects.Sprite, scene: Phaser.Scene): void {
  const grid = scene.registry.get("defenderShadowSpritesheetGrid") as
    | { frameHeight: number }
    | undefined;
  const targetHeight =
    (scene.registry.get("playerDisplayHeightPx") as number | undefined) ?? 96;
  const baseScale = grid ? targetHeight / grid.frameHeight : 2;
  sprite.setScale(baseScale * SHADOW_SCALE_MULTIPLIER);
}

/** Stationary defender shadow (raid home visit). */
export function spawnDefenderShadowProp(
  scene: Phaser.Scene,
  worldX: number,
  worldY: number,
  depth: number,
): Phaser.GameObjects.Sprite | null {
  if (!defenderShadowTexturesReady(scene)) return null;
  const key = scene.textures.exists(TEX) ? TEX : "def-shadow-idle";
  const sprite = scene.add.sprite(worldX, worldY, key, 0);
  sprite.setOrigin(0.5, 1);
  sprite.setAlpha(SHADOW_DISPLAY_ALPHA);
  applyDefenderShadowScale(sprite, scene);
  sprite.setDepth(depth);
  if (scene.anims.exists(ANIM_IDLE)) {
    sprite.play(ANIM_IDLE);
  }
  return sprite;
}
